import React from "react";
import { InfoCardView } from "./info-card-view";
import { useInfoCard } from "./use-info-card";

export const OcInfoCard = (props: any) => {
  const hookProps = useInfoCard(props);
  const parsedProps = {
    ...hookProps,
    onEdit: hookProps.onEdit ?? (() => {}),
    hasChangeRequest:
      typeof hookProps.hasChangeRequest === "function"
        ? hookProps.hasChangeRequest
        : () => !!hookProps.hasChangeRequest,
  };
  return <InfoCardView {...parsedProps} />;
};

export default OcInfoCard;
